import {api} from 'services/api';
import {Directory} from 'types/directory';
import {Option} from 'types/option';
import {ResponseData} from 'types/response-data';

const storeDirectory = api.injectEndpoints({
  endpoints: builder => ({
    storeDirectory: builder.mutation<Response, StoreDirectoryRequest>({
      query: params => {
        return {
          method: 'POST',
          url: `directories`,
          body: {
            comment: params.comment,
            company_name: params.company_name,
            description: params.description,
            directory_categories: params.categories.map(x => x.id),
            directory_families: params.families.map(x => x.id),
            directory_type: params.directory_type,
            email: params.email,
            phone: params.phone,
            first_name: params.first_name,
            gender: params.gender?.value,
            phone_number_type: params?.phone_number_type?.value,
            website: params.website,
            newsletters: params?.newsletters?.map(x => x.id),
            job: params.job,
            last_name: params.last_name,
            is_official_furniture_supplier:
              params.is_official_furniture_supplier,
            is_official_studio_supplier: params.is_official_studio_supplier,
            is_official_suppliers_small_items:
              params.is_official_suppliers_small_items,
            reference_contact_id: params.reference_contact?.id,
            requirement_rate: params.requirement_rate?.value,
            residency_country: params.residency_country?.id,
          },
        };
      },
    }),
  }),
});

export type StoreDirectoryRequest = {
  catalog?: boolean;
  categories: Option[];
  comment?: string;
  newsletters?: Option[];
  company_name?: string;
  description?: string;
  email?: string;
  families: Option[];
  website?: string;
  first_name?: string;
  gender?: Option;
  phone?: string;
  phone_number_type?: Option;
  job?: string;
  last_name?: string;
  is_official_furniture_supplier?: boolean;
  is_official_studio_supplier?: boolean;
  is_official_suppliers_small_items?: boolean;
  reference_contact?: Option;
  requirement_rate?: Option;
  residency_country?: Option;

  directory_type?: string;
};

type Response = ResponseData<Directory>;

export const {useStoreDirectoryMutation} = storeDirectory;
